export const SORT_DIRECTION = {
  asc: 'asc',
  desc: 'desc'
}

export const DEFAULT_ROWS_PER_PAGE = 10
